// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"a8501f6f1d419dfbf144","258":"b2984b19b33c92270bf2"}[chunkId] + ".js";
};